import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';
import { snakeToCamel } from '../lib/utils';

export function useProfiles() {
  return useQuery({
    queryKey: queryKeys.profiles.all,
    queryFn: async () => {
      const data = await api.get('/profiles');
      return data.map(snakeToCamel);
    },
    staleTime: 5 * 60 * 1000, // profiles rarely change
  });
}
